import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS - 3);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'hrs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-brand text-white" data-id="element-32" data-mp="ant8i1dy1vw4">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-1.5 px-4 py-1 text-[9px] font-bold uppercase leading-none tracking-[0.1em] sm:gap-2 sm:py-2 sm:text-xs sm:tracking-[0.14em]" data-id="element-33" data-mp="6nit5y49ht4l">
        <HourglassIcon className="h-2.5 w-2.5 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-34" data-mp="18dmy6aj358dc" />
        <span data-id="element-35" data-mp="ue45mq2rc5m5">Launch offer ends in:</span>
        <span className="flex items-center gap-0.5 tabular-nums sm:gap-1" aria-live="off" data-id="element-36" data-mp="uf5huxviey5g">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-0.5 sm:gap-1" data-id="element-37" data-mp="1m5jms4ljp04z" data-mpi={index}>
              <span className="text-[11px] font-extrabold sm:text-base" data-id="element-38" data-mp="1r2tl69qwwm4y">
                {pad(unit.value)}
              </span>
              <span className="text-[8px] tracking-normal opacity-90 sm:text-[9px]" data-id="element-39" data-mp="1dadmfl51na9u">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="opacity-70 sm:px-0.5" data-id="element-40" data-mp="2519qbw94m4kz">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}